import { useNavigate, useSearch } from "@tanstack/react-router";
import { useCallback } from "react";

export interface GlobalFilters {
  since?: string;
  until?: string;
  account_id?: string;
  tag_id?: string;
}

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const UUID_RE =
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

export function validateGlobalFilters(
  search: Record<string, unknown>,
): GlobalFilters {
  const result: GlobalFilters = {};
  if (typeof search.since === "string" && ISO_DATE_RE.test(search.since)) {
    result.since = search.since;
  }
  if (typeof search.until === "string" && ISO_DATE_RE.test(search.until)) {
    result.until = search.until;
  }
  if (typeof search.account_id === "string" && UUID_RE.test(search.account_id)) {
    result.account_id = search.account_id;
  }
  if (typeof search.tag_id === "string" && UUID_RE.test(search.tag_id)) {
    result.tag_id = search.tag_id;
  }
  return result;
}

export function useGlobalFilters(): GlobalFilters {
  const raw = useSearch({ strict: false }) as Record<string, unknown>;
  return validateGlobalFilters(raw);
}

export function useSetGlobalFilters() {
  const navigate = useNavigate();
  return useCallback(
    (patch: Partial<GlobalFilters>) => {
      void navigate({
        to: ".",
        search: (prev: Record<string, unknown>) => {
          const next: Record<string, unknown> = { ...prev };
          for (const [key, value] of Object.entries(patch)) {
            if (value === undefined || value === "") {
              delete next[key];
            } else {
              next[key] = value;
            }
          }
          return next;
        },
        replace: true,
      });
    },
    [navigate],
  );
}

export function hasActiveFilters(filters: GlobalFilters): boolean {
  return Boolean(
    filters.since ?? filters.until ?? filters.account_id ?? filters.tag_id,
  );
}
